import { ReactNode, createContext, useContext, useRef } from 'react';
import { enableStaticRendering } from 'mobx-react-lite';
import ExplorerRootStore from './ExplorerRootStore';

// Tell mobx-react-lite to skip observer tracking during SSR
enableStaticRendering(typeof window === 'undefined');

const StoreContext = createContext<ExplorerRootStore | null>(null);

export function StoreProvider({ children }: { children: ReactNode }) {
	const storeRef = useRef<ExplorerRootStore | null>(null);

	// Only create the store on the client side
	if (typeof window !== 'undefined' && !storeRef.current) {
		storeRef.current = ExplorerRootStore.instance;
	}

	return <StoreContext.Provider value={storeRef.current}>{children}</StoreContext.Provider>;
}

/**
 * Returns the store or null during SSR.
 * Components using this should handle the null case (e.g. return null during SSR).
 */
export function useStoreOrNull(): ExplorerRootStore | null {
	return useContext(StoreContext);
}

export function useStore(): ExplorerRootStore {
	const context = useContext(StoreContext);
	if (!context) {
		throw new Error('useStore must be used within StoreProvider and on the client side');
	}
	return context;
}
